var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"moderation-headers"},_vm._l((_vm.getHeaders),function(header){return _c('div',{key:header.value,staticClass:"moderation__element",class:[header.value === 'name' && 'moderation__element_name'],style:(`width: ${header.width}px`)},[_c('span',{staticClass:"moderation__text"},[_vm._v(" "+_vm._s(header.text)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }